// extracted by mini-css-extract-plugin
export default {"root":"OPwtBEnKMEfPSobZz5lM","header":"_e4MvD8w_eAxMThyXCUT","embed":"hcqTuRrxhuS0d16CoAxX"};